import "react-app-polyfill/ie11"
import "react-app-polyfill/stable"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"
import { ConfigProvider } from "./contexts/ConfigContext"
import "./index.scss"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import store from "./store/store"

// eslint-disable-next-line no-undef
createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <ConfigProvider>
      <App />
    </ConfigProvider>
  </Provider>
)

reportWebVitals()
